import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

/**
 * Schema for conversation agent runs which link conversations to agent runs
 */
export const ConversationAgentRunSchema = z.object({
  conversationAgentRunId: PrimaryKeySchema,
  conversationId: PrimaryKeySchema,
  agentRunId: PrimaryKeySchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ConversationAgentRun = z.infer<typeof ConversationAgentRunSchema>;

export const ConversationAgentRunsSchema = z.array(ConversationAgentRunSchema);

export type ConversationAgentRuns = z.infer<typeof ConversationAgentRunsSchema>;

export const ConversationAgentRunsQuerySchema =
  createOffsetPaginationRequestQuerySchema(
    z.enum(['createdAt', 'updatedAt']),
  ).extend({
    conversationAgentRunIds: commaDelimitedList(
      PrimaryKeySchema.array(),
    ).optional(),
    conversationIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    agentRunIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  });

export type ConversationAgentRunsQuery = z.infer<
  typeof ConversationAgentRunsQuerySchema
>;

export const CreateConversationAgentRunSchema = ConversationAgentRunSchema.pick(
  {
    conversationId: true,
    agentRunId: true,
  },
);

export type CreateConversationAgentRun = z.infer<
  typeof CreateConversationAgentRunSchema
>;
